import { RouteObject } from "react-router-dom";
import { ExpensesAdmin } from "src/routes/expenses/ExpensesAdmin";
import { InboxPage } from "src/routes/inbox/InboxPage";
import { UserProfile } from "src/routes/profile/UserProfile";
import { SearchPage } from "src/routes/search/Search";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import { expensesRoute, inboxRoute, profileRoute, searchRoute } from "src/routing/domains/rootPaths";

/**
 * Root one-off route trees (`/profile`, `/inbox`, `/expenses`, `/search`).
 *
 * Role: data router domain route.
 *
 * These pages don't share domain context. Each is its own `AppShell` tree.
 * Legacy stack (pages still use `PageHeader` / plain content, not Beam page layouts):
 * `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page.
 * When pages move to `PageHeaderLayout` / `GridTableLayout`, switch to
 * `AppShell` → `BeamNavbarLayout` → page (see `domains/projects.ts`).
 *
 * Path constants live in `rootPaths.ts` (imported by `RouteUrls.ts` / pages) to avoid a cycle
 * through this file's page `Component` imports.
 * Legacy `Routes.tsx` must not register these paths.
 */
function rootPageRoute(path: string, Component: RouteObject["Component"]): RouteObject {
  return {
    path,
    Component: AppShell,
    children: [
      {
        Component: GlobalNavLayout,
        children: [{ Component: ScrollableParentLayout, children: [{ index: true, Component }] }],
      },
    ],
  };
}

/**
 * Migrated root one-off route trees registered in `Router.tsx`.
 */
export const rootRoutes: RouteObject[] = [
  rootPageRoute(profileRoute.path, UserProfile),
  rootPageRoute(inboxRoute.path, InboxPage),
  rootPageRoute(expensesRoute.path, ExpensesAdmin),
  rootPageRoute(searchRoute.path, SearchPage),
];
